import { render, staticRenderFns } from "./ButtonNextPage.vue?vue&type=template&id=4692b537&scoped=true&"
import script from "./ButtonNextPage.vue?vue&type=script&lang=js&"
export * from "./ButtonNextPage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNextPage.vue?vue&type=style&index=0&id=4692b537&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4692b537",
  null
  
)

export default component.exports